export default __webpack_public_path__ + "static/media/cross-icon.64201ede.svg";